import {MutationTree} from 'vuex'
import i18n, { selectedLocale } from '../../helpers/i18n';


export interface State {
  locale: string,
}

const defaultState: State = {
  locale: selectedLocale
}

const getters = {
  getLocale: (state:State) => state.locale

}

const mutations: MutationTree<State> = {
  updateLocale(state:State, newLocale:string) {
    i18n.locale = newLocale // важно оставить, что б менялся язык
    state.locale = newLocale // а здесь меняем значение для переключателя
    localStorage.setItem('locale', newLocale); // запоминаем текущий язык, что б после перезагрузки страницы не сбросило на стандартный
  }
}


export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations
};
